import type { useUserProfileStrings } from './userProfile-strings';

type ProfileStrings = ReturnType<typeof useUserProfileStrings>;

function firebaseAuthErrorCode(err: unknown): string | undefined {
    if (typeof err !== 'object' || err == null || !('code' in err)) {
        return undefined;
    }
    const code = (err as { code?: unknown }).code;
    return typeof code === 'string' ? code : undefined;
}

/** User-facing copy for Firebase Auth errors during profile email verification actions. */
export function verificationAuthErrorMessage(err: unknown, fallback: string, strings: ProfileStrings): string {
    const code = firebaseAuthErrorCode(err);
    if (code === 'auth/too-many-requests') {
        return strings.verificationAuthTooManyRequests;
    }
    if (code === 'auth/network-request-failed') {
        return strings.verificationAuthNetworkError;
    }
    return fallback;
}
